(() => {
  const initGzhMegaMenuTab = () => {
    document.querySelectorAll('.modern-nav-item').forEach((item) => {
      const triggers = item.querySelectorAll('.mega-menu-tab-trigger');
      const panels = item.querySelectorAll('.mega-menu-tab-panel');

      triggers.forEach((trigger) => {
        if (trigger.dataset.gzhMegaTabBound === 'true') return;
        trigger.dataset.gzhMegaTabBound = 'true';
        trigger.addEventListener('mouseenter', () => {
          triggers.forEach((tab) => tab.classList.remove('is-active'));
          panels.forEach((panel) => panel.classList.remove('is-active'));

          trigger.classList.add('is-active');
          const targetId = trigger.getAttribute('data-tab-target');
          const activePanel = targetId ? item.querySelector(`#${targetId}`) : null;
          activePanel?.classList.add('is-active');
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGzhMegaMenuTab, { once: true });
  } else {
    initGzhMegaMenuTab();
  }

  document.addEventListener('shopify:section:load', initGzhMegaMenuTab);
})();

(() => {
  const initGzhHeaderMenu = () => {
    const closeMobileTab3Accordions = (drawer) => {
      drawer?.querySelectorAll('.js-mobile-tab3-toggle.is-open').forEach((toggle) => {
        toggle.classList.remove('is-open');
      });
      drawer?.querySelectorAll('.mobile-tab3-accordion.is-open').forEach((accordion) => {
        accordion.classList.remove('is-open');
      });
    };

    const resetMobileDrawerState = (drawer) => {
      drawer.querySelector('.mobile-drawer-content')?.scrollTo({ top: 0 });
      drawer.querySelectorAll('.js-mobile-accordion-trigger, .js-mobile-subaccordion-trigger, .js-mobile-tab3-toggle').forEach((btn) => {
        btn.classList.remove('is-open');
      });
      drawer.querySelectorAll('.mobile-nav-submenu').forEach((submenu) => {
        submenu.classList.remove('is-active');
      });
      drawer.querySelectorAll('.mobile-nav-grandchildmenu-wrapper').forEach((submenu) => {
        submenu.classList.remove('is-active');
        submenu.classList.remove('is-open');
      });
      drawer.querySelectorAll('.mobile-nav-grandchildmenu-wrapper:not(.mobile-nav-grandchildmenu-wrapper--page)').forEach((submenu) => {
        submenu.style.removeProperty('display');
      });
      closeMobileTab3Accordions(drawer);
    };

    const closeMobileDrawer = (drawer) => {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      const header = drawer.closest('#header-component');
      if (header?.dataset.gzhOriginalSticky) {
        header.setAttribute('sticky', header.dataset.gzhOriginalSticky);
        if (header.dataset.gzhOriginalStickyState) {
          header.dataset.stickyState = header.dataset.gzhOriginalStickyState;
        } else {
          delete header.dataset.stickyState;
        }
        delete header.dataset.gzhOriginalSticky;
        delete header.dataset.gzhOriginalStickyState;
      }
      const triggerDetails = document.getElementById('Details-menu-drawer-container');
      triggerDetails?.removeAttribute('open');
      triggerDetails?.classList.remove('menu-open');
      triggerDetails?.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    };

    const bindMobileDrawerControls = (drawer) => {
      if (!drawer || drawer.dataset.gzhDrawerControlsBound === 'true') return;
      drawer.dataset.gzhDrawerControlsBound = 'true';

      let touchStartY = 0;
      drawer.addEventListener('touchstart', (event) => {
        touchStartY = event.touches[0]?.clientY || 0;
      }, { passive: true });

      drawer.addEventListener('touchmove', (event) => {
        if (!drawer.classList.contains('is-open')) return;
        const content = event.target.closest('.mobile-nav-grandchildmenu-wrapper.is-active, .mobile-nav-submenu--page.is-active, .mobile-drawer-content');
        if (!content) {
          event.preventDefault();
          return;
        }

        const movingUp = touchStartY > (event.touches[0]?.clientY || touchStartY);
        const atTop = content.scrollTop <= 0;
        const atBottom = content.scrollTop + content.clientHeight >= content.scrollHeight - 1;
        if ((movingUp && atBottom) || (!movingUp && atTop)) event.preventDefault();
      }, { passive: false });

      drawer.addEventListener('wheel', (event) => {
        if (!drawer.classList.contains('is-open')) return;
        const content = event.target.closest('.mobile-nav-grandchildmenu-wrapper.is-active, .mobile-nav-submenu--page.is-active, .mobile-drawer-content');
        const atTop = !content || content.scrollTop <= 0;
        const atBottom = !content || content.scrollTop + content.clientHeight >= content.scrollHeight - 1;
        if ((event.deltaY < 0 && atTop) || (event.deltaY > 0 && atBottom)) event.preventDefault();
      }, { passive: false });

      drawer.querySelector('#MobileDrawerOverlay, .mobile-drawer-overlay')?.addEventListener('click', () => {
        closeMobileDrawer(drawer);
      });
    };

    const syncMobileDrawerSocialLinks = () => {
      const targets = document.querySelectorAll('[data-mobile-drawer-social-links]');
      if (!targets.length) return true;

      const footerSocialLinks = Array.from(document.querySelectorAll('.social-icons__wrapper')).find(
        (socialLinks) => !socialLinks.closest('.gzh-mobile-menu-mount') && socialLinks.querySelector('a')
      );
      if (!footerSocialLinks) return false;

      targets.forEach((target) => {
        if (target.dataset.socialLinksSynced === 'true') return;
        target.replaceChildren(footerSocialLinks.cloneNode(true));
        target.dataset.socialLinksSynced = 'true';
        target.closest('.mobile-drawer-social')?.removeAttribute('hidden');
      });

      return true;
    };

    const getButtonDrawer = (button) => {
      const mount = button.closest('.gzh-mobile-menu-mount');
      return mount?.querySelector('.mobile-drawer');
    };

    const openMobileDrawer = (event) => {
      event?.preventDefault();
      event?.stopPropagation();

      const button = event.currentTarget;
      const activeDrawer = getButtonDrawer(button);
      if (!activeDrawer) return;

      syncMobileDrawerSocialLinks();

      if (activeDrawer.classList.contains('is-open')) {
        closeMobileDrawer(activeDrawer);
        return;
      }

      document.querySelectorAll('.mobile-drawer.is-open').forEach((drawer) => {
        if (drawer !== activeDrawer) closeMobileDrawer(drawer);
      });

      bindMobileDrawerControls(activeDrawer);
      resetMobileDrawerState(activeDrawer);
      const header = activeDrawer.closest('#header-component');
      if (header?.getAttribute('sticky') === 'scroll-up') {
        header.dataset.gzhOriginalSticky = 'scroll-up';
        header.dataset.gzhOriginalStickyState = header.dataset.stickyState || '';
        header.setAttribute('sticky', 'always');
        header.dataset.stickyState = 'active';
      }
      activeDrawer.style.setProperty('--gzh-mobile-drawer-top', `${Math.max(0, header?.getBoundingClientRect().bottom || 0)}px`);
      activeDrawer.classList.add('is-open');
      const triggerDetails = document.getElementById('Details-menu-drawer-container');
      triggerDetails?.setAttribute('open', '');
      triggerDetails?.classList.add('menu-open');
      triggerDetails?.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    };

    const mobileMenuButton = document.getElementById('MobileMenuBtn');

    const bindMobileMenuButton = (button) => {
      if (!button) return;
      if (button.dataset.gzhDrawerBound === 'true') return;
      button.dataset.gzhDrawerBound = 'true';
      button.addEventListener('click', openMobileDrawer);
    };

    document.querySelectorAll('.gzh-mobile-menu-mount .gzh-mobile-menu-toggle').forEach(bindMobileMenuButton);
    bindMobileMenuButton(mobileMenuButton);

    document.querySelectorAll('.mobile-drawer').forEach(bindMobileDrawerControls);
    if (!syncMobileDrawerSocialLinks()) {
      const socialLinksObserver = new MutationObserver(() => {
        if (syncMobileDrawerSocialLinks()) socialLinksObserver.disconnect();
      });
      socialLinksObserver.observe(document.body, { childList: true, subtree: true });
    }

    document.querySelectorAll('.js-mobile-accordion-trigger, .js-mobile-subaccordion-trigger, .js-mobile-tab3-toggle').forEach((btn) => {
      if (btn.dataset.gzhAccordionBound === 'page-v4') return;
      btn.dataset.gzhAccordionBound = 'page-v4';
      btn.addEventListener('click', (event) => {
        event.stopImmediatePropagation();
        event.stopPropagation();
        const row = btn.closest('.mobile-nav-row');
        const submenu = row?.nextElementSibling;

        if (btn.classList.contains('js-mobile-tab3-toggle')) {
          const isOpen = btn.classList.contains('is-open');
          btn.classList.toggle('is-open', !isOpen);
          submenu?.classList.toggle('is-open', !isOpen);
          return;
        }

        if (btn.classList.contains('js-mobile-accordion-trigger')) {
          closeMobileTab3Accordions(btn.closest('.mobile-drawer'));
          submenu?.classList.add('is-active');
          btn.closest('.mobile-drawer-content')?.scrollTo({ top: 0 });
          return;
        }

        if (btn.dataset.mobileSubmenuMode === 'page') {
          submenu?.closest('.mobile-nav-submenu--page')?.scrollTo({ top: 0 });
          submenu?.classList.add('is-active');
          submenu?.scrollTo({ top: 0 });
          return;
        }

        const isOpen = btn.classList.contains('is-open');
        btn.classList.toggle('is-open', !isOpen);
        submenu?.classList.toggle('is-open', !isOpen);
      }, true);
    });

    document.querySelectorAll('.js-mobile-submenu-back').forEach((btn) => {
      if (btn.dataset.gzhBackBound === 'true') return;
      btn.dataset.gzhBackBound = 'true';
      btn.addEventListener('click', () => {
        btn.closest('.mobile-nav-submenu')?.classList.remove('is-active');
      });
    });

    document.querySelectorAll('.js-mobile-grandchildmenu-back').forEach((btn) => {
      if (btn.dataset.gzhBackBound === 'true') return;
      btn.dataset.gzhBackBound = 'true';
      btn.addEventListener('click', () => {
        btn.closest('.mobile-nav-grandchildmenu-wrapper')?.classList.remove('is-active');
      });
    });


  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGzhHeaderMenu, { once: true });
  } else {
    initGzhHeaderMenu();
  }
  })();
